import { render } from "./WindowButtons.vue?vue&type=template&id=1e21ac3a&scoped=true"
import script from "./WindowButtons.vue?vue&type=script&lang=js"
export * from "./WindowButtons.vue?vue&type=script&lang=js"

import "./WindowButtons.vue?vue&type=style&index=0&id=1e21ac3a&scoped=true&lang=css"

import exportComponent from "/builds/kmkn5581/messequiz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e21ac3a"]])

export default __exports__